export function getEnvVar(name: string): string;
export function getEnvVar(name: string, required: true): string;
export function getEnvVar(name: string, required: false): string | undefined;
export function getEnvVar(name: string, required = true): string | undefined {
   const value = process.env[name];
   if (!value && required) {
      throw new Error(`Missing environment variable ${name}!`);
   }
   return value;
}
